import { http } from '@/api/client/httpClient';
import type { Select2Option } from '@/components/forms/Select2';
import type { EnumDefinitionsResponse } from '@/api/types/enumDefinitions';

// Finkit.Common.EnumDefinitions.EnumDefinitionAppService.GetAsync
// -> GET /api/app/enum-definition?names=A,B,C (ABP strips the Get prefix).
const BASE = '/api/app/enum-definition';

export const enumDefinitionsApi = {
  getEnums: async (names: string[]): Promise<Record<string, Select2Option[]>> => {
    const { data } = await http.get<EnumDefinitionsResponse>(BASE, {
      params: { names: names.join(',') },
    });

    const result: Record<string, Select2Option[]> = {};
    for (const [name, options] of Object.entries(data ?? {})) {
      result[name] = (options ?? []).map((o) => ({ value: o.value, label: o.text }));
    }
    return result;
  },
};
